import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link, Redirect } from 'react-router-dom';

import { 
  loadKiosks,
  loadKiosk,
  addKiosk,
  editKiosk,
} from '../../reducers/kiosks';

import {
  loadMedias
} from  '../../reducers/medias';

import update from 'immutability-helper';

class KioskEditor extends Component {

  state = {
    id: null,
    mode: null,
    added: false,
    edited: false,
    permission: 'Allowed',
    kiosk: {
      kiosk_name: '',
      kiosk_description: '',
      kiosk_location: {
        address: '',
        latitude: '',
        longitude: ''
      },
      attractloop_file: undefined
    },
    errors: {
      kiosk_name: null,
    },
    canAdd: false,
    canEdit: false,
    attractloop_medias: []
  }

  componentDidMount = () => {

    window.scrollTo(0, 0);
    
    if (!isNaN(parseInt(this.props.match.params.id, 10))) {
      this.setState({mode: 'Edit', id: parseInt(this.props.match.params.id, 10)});
    } else {
      this.setState({mode: 'Add'});
    }

    this.loadAttractloopMedias()
  }

  componentDidUpdate = (prevProps, prevState) => {
    if(this.state.mode === 'Add' && prevState.mode !== this.state.mode) {
    }
    if(this.state.mode === 'Edit' && prevState.mode !== this.state.mode) {
      this.loadKioskByID();
    }

    if(!this.props.isLoadingMedias && prevProps.isLoadingMedias !== this.props.isLoadingMedias) {
      this.loadAttractloopMedias();
    }
  }

  loadAttractloopMedias = () => {
    let medias = []

    this.props.medias.forEach(media => {
      if(media.media_uploaded_id_type === 'Attract Loop') {
        medias.push(media)
      }
    })

    this.setState({ attractloop_medias: medias })
  }

  loadKioskByID = () => {
    if(this.state.id){
      this.props.loadKiosk(this.state.id, (resp) => {
        if(resp.data) {
          this.setState({kiosk: resp.data});
          this.mapKioskToFields();
          this.validateFields();
        } else {
          this.setState({permission: 'Disallowed'});
        }
      });
    }
  }

  mapKioskToFields = () => {
  }

  handleKioskNameChange = (e) => {
    this.setState(update(this.state, {kiosk: {kiosk_name: {$set: e.target.value}}}), () => {

      if(this.state.kiosk.kiosk_name.length === 0) {
        this.setState(update(this.state, {errors: {kiosk_name: {$set: 'Kiosk name must not be empty'}}}));
      } else if( this.state.kiosk.kiosk_name.length > 0) {
        this.setState(update(this.state, {errors: {kiosk_name: {$set: null}}}));
      }

      this.validateFields();
    });
  }

  handleKioskDescriptionChange = (e) => {
    this.setState(update(this.state, {kiosk: {kiosk_description: {$set: e.target.value}}}), () => {
    });
  }

  handleKioskLocationAddressChange = (e) => {
    this.setState(update(this.state, {kiosk: {kiosk_location: {address: {$set: e.target.value}}}}));
  }

  handleKioskLocationLatitudeChange = (e) => {
    this.setState(update(this.state, {kiosk: {kiosk_location: {latitude: {$set: e.target.value}}}}));
  }

  handleKioskLocationLongitudeChange = (e) => {
    this.setState(update(this.state, {kiosk: {kiosk_location: {longitude: {$set: e.target.value}}}}));
  }

  handleKioskAttractloopChange = (e) => {
    this.setState(update(this.state, {kiosk: {attractloop_file: {$set: e.target.value}}}), () => {

    });
  }

  addKiosk = () => {
    const kiosk = Object.assign({}, this.state.kiosk);
    delete kiosk.kiosk_id; 

    kiosk.address = kiosk.kiosk_location.address;

    if(!kiosk.address){
      kiosk.address = null;
    }
    kiosk.latitude = kiosk.kiosk_location.latitude;
    if(!kiosk.latitude){
      kiosk.latitude = null;
    }
    kiosk.longitude = kiosk.kiosk_location.longitude;
    if(!kiosk.longitude){
      kiosk.longitude = null;
    } 
    kiosk.is_active = 1;

    delete kiosk.kiosk_location;

    if(!kiosk.attractloop_file) {
      kiosk.attractloop_file = null
    }

    const data = new FormData()
    data.append('data', JSON.stringify(kiosk));

    this.props.addKiosk(data, (resp) => {
      this.setState({added: true});
      this.props.loadKiosks();
    });
  }

  editKiosk = () => {
    const kiosk = Object.assign({}, this.state.kiosk);
    delete kiosk.kiosk_id;

    kiosk.address = kiosk.kiosk_location.address;
    if(!kiosk.address){
      kiosk.address = null;
    }
    kiosk.latitude = kiosk.kiosk_location.latitude;
    if(!kiosk.latitude){
      kiosk.latitude = null;
    }
    kiosk.longitude = kiosk.kiosk_location.longitude;
    if(!kiosk.longitude){
      kiosk.longitude = null;
    }
    kiosk.is_active = 1;

    delete kiosk.kiosk_location;

    if(!kiosk.attractloop_file) {
      kiosk.attractloop_file = null
    }

    const data = new FormData()
    data.append('data', JSON.stringify(kiosk));

    this.props.editKiosk(this.state.id, data, (resp) => {
      this.setState({edited: true});
      this.props.loadKiosks();
    });
  }

  validateFields = () => {
    let flag = true;

    if(this.state.kiosk.kiosk_name.length === 0) {
      flag = false;
    } else if( this.state.kiosk.kiosk_name.length > 0) {
    }

    if(flag) {
      if(this.state.mode === 'Add') {
        this.setState({canAdd: true});
      } else if (this.state.mode === 'Edit') {
        this.setState({canEdit: true});
      }
    } else {
      if(this.state.mode === 'Add') {
        this.setState({canAdd: false});
      } else if (this.state.mode === 'Edit') {
        this.setState({canEdit: false});
      }
    }

  }

  render() {

    if (this.state.permission !== 'Allowed' || this.state.added || this.state.edited) {
      return <Redirect to='/kiosks'/>;
    }

    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>{this.state.mode === 'Add' ? 'Add' : ''}{this.state.mode === 'Edit' ? 'Edit' : ''} Kiosk</PageTitle>

          <div className="container-fluid">
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">
              <div className="col-md-4 offset-md-8 text-right">
                <Link to='/kiosks'><button className="btn btn-light" style={{marginRight: '10px'}}>Cancel</button></Link>
                {this.state.mode === 'Add' &&
                  <button className="btn btn-primary" onClick={this.addKiosk} disabled={this.props.isAddingKiosk || !this.state.canAdd} >Add Kiosk</button>
                }
                {this.state.mode === 'Edit' &&
                  <button className="btn btn-primary" onClick={this.editKiosk} disabled={this.props.isEditingKiosk || !this.state.canEdit} >Edit Kiosk</button>
                }
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h3>Kiosk Details</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <form>
                  <div className="form-group">
                    <label htmlFor="kioskName">Kiosk Name *</label>
                    <input type="text" className="form-control" id="kioskName" value={this.state.kiosk.kiosk_name} onChange={this.handleKioskNameChange} placeholder="Kiosk Name" autoFocus />
                    {this.state.errors.kiosk_name &&
                      <small id="kioskNameError" className="form-text text-muted">{this.state.errors.kiosk_name}</small>
                    }
                  </div>
                  <div className="form-group">
                    <label htmlFor="kioskDescription">Kiosk Description</label>
                    <textarea className="form-control" id="kioskDescription" rows="3" value={this.state.kiosk.kiosk_description} onChange={this.handleKioskDescriptionChange} ></textarea>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h3>Kiosk Location</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <form>
                  <div className="form-group">
                    <label htmlFor="kioskLocationAddress">Kiosk Address</label>
                    <input type="text" className="form-control" id="kioskLocationAddress" value={this.state.kiosk.kiosk_location.address} onChange={this.handleKioskLocationAddressChange} placeholder="Kiosk Location Address" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="kioskLocationLatitude">Kiosk Latitude</label>
                    <input type="number" className="form-control" id="kioskLocationLatitude" value={this.state.kiosk.kiosk_location.latitude} onChange={this.handleKioskLocationLatitudeChange} placeholder="Kiosk Location Latitude" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="kioskLocationLongitude">Kiosk Longitude</label>
                    <input type="number" className="form-control" id="kioskLocationLongitude" value={this.state.kiosk.kiosk_location.longitude} onChange={this.handleKioskLocationLongitudeChange} placeholder="Kiosk Location Longitude" />
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h3>Kiosk Attractloop</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <form>
                  <div className="form-group">
                    <label htmlFor="kioskLocationAddress">Attractloop</label>
                    <select className="form-control" id="kioskAttractLoop" value={ this.state.kiosk.attractloop_file } onChange={ this.handleKioskAttractloopChange }>
                      <option value={undefined}>None</option>
                      {this.state.attractloop_medias.map((e, key) => {
                        return <option key={ e.media_uploaded_id } value={ e.media_attachment.media_name }>{ e.media_attachment.media_name }</option>
                      })}
                    </select>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <hr />
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">
              <div className="col-md-4 offset-md-8 text-right">
                <Link to='/kiosks'><button className="btn btn-light" style={{marginRight: '10px'}}>Cancel</button></Link>
                {this.state.mode === 'Add' &&
                  <button className="btn btn-primary" onClick={this.addKiosk} disabled={this.props.isAddingKiosk || !this.state.canAdd} >Add Kiosk</button>
                }
                {this.state.mode === 'Edit' &&
                  <button className="btn btn-primary" onClick={this.editKiosk} disabled={this.props.isEditingKiosk || !this.state.canEdit} >Edit Kiosk</button>
                }
              </div>
            </div>
          </div>

        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  kiosks: state.kiosks.kiosks,
  isLoadingKiosk: state.kiosks.isLoadingKiosk,
  isAddingKiosk: state.kiosks.isAddingKiosk,
  isEditingKiosk: state.kiosks.isEditingKiosk,
  medias: state.medias.medias,
  isLoadingMedias: state.medias.isLoadingMedias
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadKiosk,
      loadKiosks,
      addKiosk,
      editKiosk,
      loadMedias
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(KioskEditor);


// WEBPACK FOOTER //
// ./src/modules/Kiosks/KioskEditor.js